module.exports = __webpack_public_path__ + "04_bob_black.69a789fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_bob_black.png
// module id = agC1
// module chunks = 0